export default "__VITE_ASSET__DfvZuUop__"